// Loads runtime config injected by scripts/inject-config.cjs at build time.
// Falls back to environment-specific defaults for local dev.

let _config = null;

export async function loadConfig() {
  if (_config) return _config;

  try {
    const module = await import("./config.generated.json");
    _config = module.default;
    console.log("Config loaded:", _config);
    return _config;
  } catch {
    // config.generated.json not present — use dev defaults
    _config = {
      apiBaseUrl: "http://localhost:8004/api/v1/katpack",
      appBaseUrl: "http://localhost:3000",
      docsUrl: "http://localhost:8001",
      katbotUrl: "http://localhost:3000",
      arbitrumChainId: 421614,
      arbitrumRpcUrl: "https://sepolia-rollup.arbitrum.io/rpc",
      environment: "local",
    };
    console.warn("config.generated.json not found, using dev defaults:", _config);
    return _config;
  }
}
